import { render, staticRenderFns } from "./ResidentInfoEdit.vue?vue&type=template&id=b84055fe&scoped=true&"
import script from "./ResidentInfoEdit.vue?vue&type=script&lang=js&"
export * from "./ResidentInfoEdit.vue?vue&type=script&lang=js&"
import style0 from "./ResidentInfoEdit.vue?vue&type=style&index=0&id=b84055fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84055fe",
  null
  
)

export default component.exports